export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6582.4e8b6c68.jpg";